//import 'ol/ol.css';
import { IAPIResult } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { ICAMSContact } from '../Shared/Contacts/ContactsModels';

enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_modals2 ='#placeholder-for-modals2',

    submissionIssueEditTaskListModal = '#submissionIssueEditTaskListModal',
    submissionIssueEditTaskListCancelBtn = '#submissionIssueEditTaskListCancelBtn',
    submissionIssueEditTaskListCloseBtn = '#submissionIssueEditTaskListCloseBtn',
    submissionIssueEditTaskListTable = '#submissionIssueEditTaskListTable',
    submissionIssueEditTaskListCreateBtn = '#submissionIssueEditTaskListCreateBtn',
    submissionIssueEditTaskListSubmitBtn = '#submissionIssueEditTaskListSubmitBtn',

    submissionIssueEditTaskModal = '#submissionIssueEditTaskModal',
    submissionIssueEditTaskModalForm = '#submissionIssueEditTaskModalForm',
    submissionIssueEditTaskModalCloseBtn = '#submissionIssueEditTaskModalCloseBtn',
    submissionIssueEditTaskModalCancelBtn = '#submissionIssueEditTaskModalCancelBtn',
    submissionIssueEditTaskModalSubmitBtn = '#submissionIssueEditTaskModalSubmitBtn',

    submissionIssueEditTaskListTable_TypeEditBtn = '#submissionIssueEditTaskListTable_TypeEditBtn',
    submissionIssueEditTaskListTable_NotesEditBtn = '#submissionIssueEditTaskListTable_NotesEditBtn'
}

declare let moment: any; // Date helper from moment()

export class SubmissionList_Tasks {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private tasks: Array<any> = [];
    private defaultTask: any = {};

    // List of buttions in the action toolbar
    private actionBtns = {
        submit: { btn: null, enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openSubmissionIssueEditTaskListModal = (maintCode: string, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_modals).load(window.G_SITEFOLDERNAME +'/Submissions/SubmissionIssueEditList', { maintCode: maintCode }, function (response, status, xhr) {
            Utilities.UnBlockUI();

            // Modal
            Utilities.GetModal(jqc.submissionIssueEditTaskListModal, ModalAction.Create);

            // Convert JSON data
            self.parseTaskJSON();

            // Buttons
            self.actionBtns.submit.btn = $('#submissionIssueEditTaskListSubmitBtn');

            // Table
            var table: any = Utilities.GetControl(jqc.submissionIssueEditTaskListTable)
            table.bootstrapTable();
            table.bootstrapTable('load', self.tasks);
            table.on('check.bs.table', function (e, row, $element) {
                self.checkVisibleButtons();
            });
            table.on('uncheck.bs.table', function (e, row, $element) {
                self.checkVisibleButtons();
            });
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                //if (field == "Notes") {
                //    self.setTableEdit_NotesCell("Notes", value, row, $element);
                //}
                //else if (field == "TypeDescr") {
                //    self.setTableEdit_TypeCell("TypeDescr", value, row, $element);
                //}
                
                if (field == "Delete") {
                    table.bootstrapTable('remove', {
                        field: 'id',
                        values: [row.id]
                    })

                    self.tasks = self.tasks.filter(t => t.id !== row.id);
                }
                else {
                    var task = self.tasks.find(t => t.id == row.id);
                    self.openSubmissionIssueEditTaskModal(task, function (updatedTask) {
                        Utilities.GetModal(jqc.submissionIssueEditTaskListModal, ModalAction.Show);
                        if (updatedTask != null) {
                            self.tasks.forEach((t, i) => {
                                if (t['id'] == updatedTask['id']) t = updatedTask;
                            });

                            var table: any = Utilities.GetControl(jqc.submissionIssueEditTaskListTable)
                            table.bootstrapTable('load', self.tasks);
                        }

                        self.checkVisibleButtons();
                    });
                }
            });

            // Check btn visibility
            self.checkVisibleButtons();

            // CANCEL Button
            Utilities.GetControl(jqc.submissionIssueEditTaskListCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.submissionIssueEditTaskListModal, ModalAction.Hide);
                toastr.info('Warning: No Tasks will be created for the Issue, so you will need to manually add Tasks to the Issue on the Issue Edit form.');
                callback();
            });

            // CREATE Button
            Utilities.GetControl(jqc.submissionIssueEditTaskListCreateBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.submissionIssueEditTaskListModal, ModalAction.Hide);

                // Get the task
                var taskClone = { ...self.defaultTask };
                self.openSubmissionIssueEditTaskModal(taskClone, function (updatedTask) {
                    Utilities.GetModal(jqc.submissionIssueEditTaskListModal, ModalAction.Show);
                    if (updatedTask != null) {
                        var maxId = Math.max(...self.tasks.map(o => o.id))
                        updatedTask['id'] = maxId >=0 ? maxId + 1 : 0;
                        self.tasks.push(updatedTask);

                        var table: any = Utilities.GetControl(jqc.submissionIssueEditTaskListTable)
                        table.bootstrapTable('load', self.tasks);
                    }

                    self.checkVisibleButtons();
                });
            });

            // SUBMIT Button
            Utilities.GetControl(jqc.submissionIssueEditTaskListSubmitBtn).on('click', function (evt) {
                self.submitTasks(maintCode, callback);
            });

        });
    }

    public openSubmissionIssueEditTaskModal = (task: any, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_modals2).load(window.G_SITEFOLDERNAME +'/Submissions/SubmissionIssueEditTaskModal', { task: task }, function (response, status, xhr) {
            Utilities.UnBlockUI();

            // Update the modal
            Utilities.GetModal(jqc.submissionIssueEditTaskModal, ModalAction.Create);

            // Set the field values
            var assignToFieldVal = Utilities.GetControl(jqc.submissionIssueEditTaskModal + ' [name="AssignedToListName"]').val();
            if (assignToFieldVal == "")  assignToFieldVal= Utilities.GetControl(jqc.submissionIssueEditTaskModal + ' [name="AssignedToTypeDescr"]').val();
            Utilities.GetControl(jqc.submissionIssueEditTaskModal + ' [name="assignToField"]').val(assignToFieldVal);
          
            // Buttons
            Utilities.GetControl(jqc.submissionIssueEditTaskModalCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.submissionIssueEditTaskModal, ModalAction.Hide);
                callback();
            });

            Utilities.GetControl(jqc.submissionIssueEditTaskModalCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.submissionIssueEditTaskModal, ModalAction.Hide);
                callback();
            });

            Utilities.GetControl(jqc.submissionIssueEditTaskModalSubmitBtn).on('click', function (evt) {
                // Check all fields are valid
                var isValid: Boolean = true;
                var fields = [
                    Utilities.GetControl(jqc.submissionIssueEditTaskModal + ' [name="CreatedDate"]'),
                    Utilities.GetControl(jqc.submissionIssueEditTaskModal + ' [name="ResponsibleOfficer"]'),
                    Utilities.GetControl(jqc.submissionIssueEditTaskModal + ' [name="Type"]'),
                ];
                fields.forEach(f => {
                    if (self.checkRequiredFields(f) == false) isValid = false;
                });
                if (isValid == false) {
                    toastr.error("Please enter the required fields.");
                    return;
                }

                // Get the data and add uit back to the task variavble
                let formData = new FormData(<any>Utilities.GetControl(jqc.submissionIssueEditTaskModalForm)[0]);
                for (var key in task) {
                    task[key] = formData.get(key);
                }

                task['TypeDescr'] = Utilities.GetControl(jqc.submissionIssueEditTaskModal + ' [name="Type"] option:selected').text();
                Utilities.GetModal(jqc.submissionIssueEditTaskModal, ModalAction.Hide);
                callback(task);
            });

            // Contacts
            Utilities.GetControl(jqc.submissionIssueEditTaskModal + ' [name="assignToField"]').on('click', function (evt) {
                Utilities.GetModal(jqc.submissionIssueEditTaskModal, ModalAction.Hide);
                events.bus.publish(events.eventOpenTasksAssignPanel([[task.id], { submitResponse: false, showUnassignBtn: false }, function (result: ICAMSContact) {
                    Utilities.GetModal(jqc.submissionIssueEditTaskModal, ModalAction.Show);
                    if (result.ContactRef != null && result.ContactRef != "") {
                        Utilities.GetControl(jqc.submissionIssueEditTaskModalForm + ' [name="AssignedToType"]').val('');
                        Utilities.GetControl(jqc.submissionIssueEditTaskModalForm + ' [name="AssignedToTypeDescr"]').val('');
                        Utilities.GetControl(jqc.submissionIssueEditTaskModalForm + ' [name="AssignedTo"]').val(result.ContactRef);
                        Utilities.GetControl(jqc.submissionIssueEditTaskModalForm + ' [name="assignToField"]').val(result.ListName);
                    }
                    else {
                        Utilities.GetControl(jqc.submissionIssueEditTaskModalForm + ' [name="AssignedToType"]').val(result.ContactType);
                        Utilities.GetControl(jqc.submissionIssueEditTaskModalForm + ' [name="AssignedTo"]').val('');
                        Utilities.GetControl(jqc.submissionIssueEditTaskModalForm + ' [name="AssignedToListName"]').val('');
                        Utilities.GetControl(jqc.submissionIssueEditTaskModalForm + ' [name="assignToField"]').val(result.ContactTypeDescr);
                    }
                }]));
            });
        });
    }

    // ----------------------------------------------------------- //
    // Submit tasks
    private submitTasks = (maintCode: string, callback: Function): void => {
        let self = this;

        var data = { maintCode: maintCode, tasks: self.tasks };
        Utilities.BlockUI($(jqc.submissionIssueEditTaskListModal));
        $.post('/Submissions/CreateTasks', data, function (result: IAPIResult) {
            try {
                if (result.success == true) {
                    Utilities.GetModal(jqc.submissionIssueEditTaskListModal, ModalAction.Hide);
                    callback();
                }
                else {
                    toastr.error('Failed to create tasks!');
                }
            }
            catch (err) {
                console.log(err);
                alert(err); 
            }
            finally {
                Utilities.UnBlockUI($(jqc.submissionIssueEditTaskListModal));
            }
        });
    }

    // ----------------------------------------------------------- //
    // CHECK BUTTONS
    private checkVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.submissionIssueEditTaskListTable);
        if (table[0] == undefined) return;

        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            self.actionBtns[k].enable = false;
        });

        self.actionBtns.submit.enable = true;
        // Then switch on the ones we want depending on the nde type
        if (rows && rows.length == 1) {

        }
        else if (rows && rows.length > 1) {
            //self.highlightsActionBtns.delete.enable = true;
        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // MISC
    private parseTaskJSON = (): void => {
        const self = this;
 
        var taskStr = Utilities.GetControl(jqc.submissionIssueEditTaskListModal + ' [data-tasks]').text();
        var tasks: Array<any> = JSON.parse(taskStr);
        self.tasks = [];
        tasks.forEach((t, i) => {
            var t2 = {};
            for (var key in t) {
                var k1 = key.substr(0, 1).toUpperCase() + key.substr(1, key.length - 1); // capitalize the first value
                t2[k1] = t[key];
            }

            t2['id'] = i;
            self.tasks.push(t2);
        });

        var defaultTaskStr = Utilities.GetControl(jqc.submissionIssueEditTaskListModal + ' [data-defaulttask]').text();
        var defaultTask: any = JSON.parse(defaultTaskStr);
        self.defaultTask = {};
        for (var key in defaultTask) {
            var k1 = key.substr(0, 1).toUpperCase() + key.substr(1, key.length - 1); // capitalize the first value
            self.defaultTask[k1] = defaultTask[key];
        }

        self.defaultTask['id'] = 0;
    }

    private checkRequiredFields = (el: JQuery<HTMLElement>): Boolean => {
        let valid = true;
        el.each(function () {
            if ($(this).val() == null || $(this).val() == "") {
                $(this).parent().find('span').html('Please enter a value');
                valid = false;
            }
            else {
                $(this).parent().find('span').html(null);
            }
        });

        return valid;
    }

    // ----------------------------------------------------------- //
    // INLINE EDIT
    private setTableEdit_TypeCell = (field, value, row, $element): void => {
        const self = this;
  
        // Check if this cell is already in edit mode, if it is, then return
        if ($element.data('isediting') == true) return;
        else $element.data('isediting', true);

        // Set the null value
        if (value == "null" || value == null) value = "";

        // Create an input element
        var selectEl = Utilities.GetControl(jqc.submissionIssueEditTaskListModal + ' [name="TaskTypeList"]').clone();
        selectEl.removeClass('d-none');
        selectEl.val(row["Type"]);
        $element.find('select').remove();
        $element.append(selectEl);

        // Hide the text element
        $element.find('div').css('display', 'none');

        // On select
        $element.find('select').on('change', function () {
            var selectedText = $(this).find('option:selected').text();
            $element.find('div span').text(selectedText); // Update the element text
            $element.find('div').css('display', 'block');

            row["Type"] = $(this).val(); // Update the table data
            $(this).remove(); // Remove the input element
            $element.data('isediting', false) // set to not editing

            // Add the results to an object for submission later on
            self.tasks.forEach(t => {
                if (t.id == row.id) t["Type"] = row["Type"];
            });
        });

        // Focus the input element
        $element.find('select').click();
    }

    private setTableEdit_NotesCell = (field, value, row, $element): void => {
        const self = this;

        // Check if this cell is already in edit mode, if it is, then return
        if ($element.data('isediting') == true) return;
        else $element.data('isediting', true);

        // Set the null value
        if (value == "null" || value == null) value = "";

        // Create an input element
        var inputEl = document.createElement('input');
        inputEl.setAttribute('type', 'text');
        inputEl.setAttribute('value', value);
        inputEl.setAttribute('style', 'width: 100%');
        $element.append(inputEl);

        // Hide the text element
        $element.find('div').css('display', 'none');

        // On lose focus
        $element.find('input').on('focusout', function () {
            $element.find('div span').text($(this).val()); // Update the element text
            $element.find('div').css('display', 'block');

            row[field] = $(this).val(); // Update the table data
            $(this).remove(); // Remove the input element
            $element.data('isediting', false) // set to not editing

            // Add the results to an object for submission later on
            var task = self.tasks.find(t => t.id == row.id);
            task[field] = row[field];
        });

        // Focus the input element
        $element.find('input').focus();
        $element.find('input')[0].setSelectionRange(value.length, value.length); // Scroll to the end of the text
    }
}


